<template>
  <InfoCard
    checkboxId="product-safety-visuals-apply-variants"
    showApplyToVariants
    :applyToVariants="applyToVariants"
    :isSaving="combinedIsSaving"
    :showSuccessState="showSuccessState"
    :isSaved="combinedIsSaved"
    :saveButtonWidth="showSuccessState ? 'auto' : '183px'"
    @saveChanges="handleSaveChanges"
    @update:applyToVariants="$emit('update:applyToVariants', $event)"
  >
    <div class="file-upload-section">
        <div class="product-safety-images">
          <div class="product-safety-images-header">
             <div>Ürün Güvenliği Görselleri</div>
            <div
              v-if="selectedImages.length > 0"
              class="header-edit-container"
              :class="{ disabled: isProductDisabled }"
              @click="!isProductDisabled && addedSafetyImageModalEdit()"
            >
              <img src="@/assets/images/icons/edit.svg" class="edit-icon" />
              <div class="product-safety-images-header-edit">Düzenle</div>
            </div>
          </div>
          <p>
            Ürünün ambalajı ve güvenlik uyarıları hakkında bilgilendirme sağlar.
          </p>
          <div class="add-image-button-container" :class="{ disabled: isProductDisabled }">
            <img
              v-for="image in selectedImages"
              :key="image.key"
              :src="image.image"
              class="add-image-button-placeholder"
            />
            <button
              class="add-button"
              :class="{ disabled: isProductDisabled }"
              v-if="selectedImages.length < 8"
              @click="onEditImagesClick"
            >
              <img
                src="@/assets/images/icons/add-safety-image.svg"
                alt="Güvenlik Görseli Ekle"
              />
              <p class="add-button-text">
                Güvenlik <br />
                Görseli Ekle
              </p>
            </button>
          </div>
        </div>
        <Modal
          @modalClosed="handleSafetyImageModalClosed"
          ref="addedSafetyImageModalRef"
          class="added-safety-image-modal"
          withCloser
          :showIcon="false"
          :modalStyle="{ width: '915px', height: modalImageHeight, zIndex: '9' }"
        >
          <template v-slot:body>
            <div class="upload-area-header">Görsel Yükle</div>
            <div
              v-if="sortableImagesContentOpen"
              class="sortable-images-area"
              @dragover.prevent="onImageDragOver"
              @drop.prevent="onImageDrop"
            >
              <div class="sortable-header">
                <div class="sortable-header-title">
                  Ürün Güvenliği Görselleri
                </div>
                <div class="ready-count">
                  <strong class="bold">{{ selectedImages.length }} / 8 </strong
                  >görsel yüklenmeye hazır.
                </div>
                <div class="failed-count" v-if="failedFiles.length > 0">
                  <img
                    width="16px"
                    height="16px"
                    src="@/assets/images/icons/alert-circle.svg"
                    alt="Error Icon"
                  />
                  <div>{{ failedFiles.length }} görsel yüklenemedi!</div>
                </div>
              </div>
              <div class="sortable-content">
                <Sortable
                  :list="selectedImages"
                  item-key="key"
                  @end="(event) => handleImageOrderChange(event)"
                  tag="div"
                  class="sortable-images-container"
                  :options="{
                    draggable: '.selectedImages',
                    animation: 150,
                    ghostClass: 'ghost',
                    dragClass: 'sortable-drag',
                    handle: '.customize-dnd_handle',
                    group: 'testgroup',
                    scroll: true,
                    forceFallback: true,
                    bubbleScroll: true,
                  }"
                >
                  <template #item="{ element, index }">
                    <div class="selectedImages">
                      <div class="selectedImages-wrapper">
                        <Icons
                          name="Delete"
                          class="delete-icon"
                          color="#FF44EE"
                          size="sm"
                          @click="deleteSafetyImage(index)"
                        />
                        <div class="sortable-images">
                          <img :src="element.image" class="image" />
                          <div class="image-info">
                            <div class="image-title">{{ element.title }}</div>
                            <div class="image-status">
                              <span class="ready-status"></span>
                              <span>Yüklenmeye Hazır</span>
                            </div>
                          </div>
                        </div>
                        <span class="customize-dnd_handle">
                          <Handler />
                        </span>
                      </div>
                    </div>
                  </template>
                </Sortable>
                <div
                  class="sortable-drag-item-failed"
                  v-for="failedFile in failedFiles"
                  :key="failedFile.key"
                >
                  <Icons
                    name="Delete"
                    class="delete-icon"
                    color="#FF44EE"
                    size="sm"
                    @click="deleteFailedImage(failedFile.key)"
                  />
                  <img
                    src="@/assets/images/icons/image-placeholder.svg"
                    class="image-failed"
                  />
                  <div class="failed-image-info">
                    <div class="failed-image-title">
                      {{ failedFile.fileName }}
                    </div>
                    <div class="failed-image-status">
                      <img
                        width="16px"
                        height="16px"
                        src="@/assets/images/icons/alert-circle.svg"
                        alt="Error Icon"
                      />
                      <div>Yüklenemedi</div>
                    </div>
                    <div
                      class="failed-image-description"
                      v-html="failedFile.errorMessage"
                    ></div>
                  </div>
                </div>
                <div
                  class="sortable-drag-area"
                  v-if="selectedImages.length < 8"
                >
                  <button
                    class="sortable-drag-item"
                    @click="handleSortableImageSelect"
                  >
                    <img src="@/assets/images/icons/plus.svg" />
                    <span class="sortable-drag-item-button">Görsel Yükle</span>
                    <span>Bilgisayardan seçin veya sürükleyip bırakın.</span>
                  </button>
                  <div
                    v-for="n in 8 - selectedImages.length"
                    :key="n"
                    class="sortable-drag-item-placeholder"
                  ></div>
                </div>
              </div>
              <div class="sortable-images-info">
                <Icons name="InfoCircle" color="$colorD40" />
                Görsellerin yerini değiştirmek için sürükleyip bırakın.
              </div>
            </div>
            <div
              class="image-upload-area"
              v-else
              @dragover.prevent="onImageDragOver"
              @drop.prevent="onImageDrop"
            >
              <img src="@/assets/images/image-upload@2x.png" />
              <div class="image-upload-header">Ürün Güvenliği Görseli Yükle</div>
              <span class="image-upload-description">Görselleri yüklemek için bilgisayarınızdan seçin veya buraya sürükleyip bırakın.</span>
              <span class="image-upload-info">(En fazla 8 görsel yükleyebilirsiniz.)</span>
              <AppButton primary md title="Dosya Seç" class="image-upload-button" @click="handleImageSelect" />
              <span class="image-upload-note">Görseller <strong>.jpeg, .jpg, .png</strong> veya <strong>.webp</strong> formatında ve en fazla <strong>10 MB</strong> boyutunda olmalıdır.</span>
            </div>
            <div class="image-upload-modal-buttons-images">
              <AppButton
                secondary
                md
                title="Vazgeç"
                class="image-upload-button"
                @click="handleCancelImageModal"
              />
              <AppButton
                :disabled="failedFiles.length > 0"
                primary
                md
                title="Yükle"
                class="image-upload-button"
                @click="uploadSafetyImages"
              />
            </div>
          </template>
        </Modal>
        <input
          ref="fileInput"
          type="file"
          @change="onFileChange"
          hidden
          accept="image/jpeg,image/png,image/jpg,image/webp"
          multiple
        />
        <input
          ref="documentFileInput"
          type="file"
          @change="onDocumentFileChange"
          hidden
          accept="application/pdf"
          multiple
        />
        <div class="products-guide">
          <div class="products-guide-header">
            <div class="products-guide-header-title">
              <div>Ürün Kılavuzları</div>
              <div
                v-if="selectedDocuments.length > 0"
                class="header-edit-container"
                :class="{ disabled: isProductDisabled }"
                @click="onEditDocumentsClick"
              >
                <img src="@/assets/images/icons/edit.svg" class="edit-icon" />
                <div class="products-guide-header-title-edit">Düzenle</div>
              </div>
            </div>
            <p>
              Kılavuzlar ve rehberler de dahil olmak üzere ürün belgeleri, doğru
              ürün kullanımı için önemli bilgileri sağlayabilir.
            </p>
          </div>
          <div class="add-document-button-container" :class="{ disabled: isProductDisabled }">
            <div
              v-for="(doc) in selectedDocuments.slice(0, 3)"
              :key="doc.key"
              class="add-document-button-item"
            >
              <img src="@/assets/images/icons/pdf.svg" alt="Belge" />
              <span>{{ doc.fileName }}</span>
            </div>
            <button
              v-if="selectedDocuments.length + failedDocuments.length < 3"
              class="add-button"
              :class="{ disabled: isProductDisabled }"
              @click="!isProductDisabled && addedSafetyDocumentModal()"
            >
              <img
                src="@/assets/images/icons/pdf-upload.svg"
                alt="Belge Ekle"
              />
              <p class="add-button-text">Belge Ekle</p>
            </button>
          </div>
        </div>
    </div>
    <Modal
      @modalClosed="handleSafetyDocumentModalClosed"
      ref="addedSafetyDocumentModalRef"
      class="added-safety-document-modal"
      withCloser
      :showIcon="false"
      :modalStyle="{ width: '896px', height: '475px', zIndex: '9' }"
    >
      <template v-slot:body>
        <div class="upload-area-header">Belge Yükle</div>
        <div
          v-if="uploadDocumentsModalOpen"
          class="upload-document-area"
          @dragover.prevent="onDocumentDragOver"
          @drop.prevent="onDocumentDrop"
        >
          <div class="upload-document-header">
            <div class="upload-document-header-title">Ürün Kılavuzları</div>
            <div class="ready-count">
              <strong class="bold">{{ selectedDocuments.length }} / 3 </strong
              >belge yüklenmeye hazır.
            </div>
            <div class="failed-count" v-if="failedDocuments.length > 0">
              <img
                width="16px"
                height="16px"
                src="@/assets/images/icons/alert-circle.svg"
                alt="Error Icon"
              />
              <div>{{ failedDocuments.length }} belge yüklenemedi!</div>
            </div>
          </div>
          <div class="upload-document-content">
            <Sortable
              :list="selectedDocuments"
              item-key="key"
              @end="(event) => handleDocumentOrderChange(event)"
              tag="div"
              class="sortable-documents-container"
              :options="{
                draggable: '.upload-document-content-item',
                animation: 150,
                ghostClass: 'ghost',
                dragClass: 'sortable-drag',
                handle: '',
                group: 'documents',
                scroll: true,
                forceFallback: true,
                bubbleScroll: true,
              }"
            >
              <template #item="{ element }">
                <div class="upload-document-content-item">
                  <div class="upload-document-content-item-info">
                    <img src="@/assets/images/icons/pdf.svg" />
                    <div class="upload-document-content-info-text">
                      <span>{{ element.fileName }}</span>
                      <span>15 MB</span>
                    </div>
                    <div>
                      <Icons
                        name="Delete"
                        class="delete-icon"
                        color="#5D3EBC"
                        size="sm"
                        @click="handleDeleteDocument(element.key)"
                      />
                    </div>
                    <span class="customize-dnd_handle">
                      <Handler />
                    </span>
                  </div>
                  <div class="upload-document-content-item-status">
                    <span class="ready-status"></span>
                    <span>Dosya yüklenmeye hazır.</span>
                  </div>
                </div>
              </template>
            </Sortable>
            <div
              class="upload-document-content-item upload-document-failed"
              v-for="failedDoc in failedDocuments"
              :key="failedDoc.key"
            >
              <div class="upload-document-content-item-info">
                <img src="@/assets/images/icons/pdf.svg" />
                <div class="upload-document-content-info-text">
                  <span class="upload-document-content-info-text-title">{{
                    failedDoc.fileName
                  }}</span>
                </div>
                <div>
                  <Icons
                    name="Delete"
                    class="delete-icon"
                    color="#5D3EBC"
                    size="sm"
                    @click="handleDeleteDocument(failedDoc.key)"
                  />
                </div>
              </div>
              <div class="upload-document-failed-header">
                <img
                  width="16px"
                  height="16px"
                  src="@/assets/images/icons/alert-circle.svg"
                  alt="Error Icon"
                />
                <span>Yüklenemedi!</span>
              </div>
              <span
                class="upload-document-failed-error-message"
                v-html="failedDoc.errorMessage"
              ></span>
            </div>
            <button
              class="upload-document-content-button"
              v-if="selectedDocuments.length + failedDocuments.length < 3"
              @click="handleDocumentSelect"
            >
              <img src="@/assets/images/icons/plus.svg" />
              <span>Belge Yükle</span>
              <span class="upload-document-button-text">Dosya Seç</span>
            </button>
          </div>
        </div>
        <div
          v-else
          class="image-upload-area image-upload-area-documents"
          @dragover.prevent="onDocumentDragOver"
          @drop.prevent="onDocumentDrop"
        >
          <img src="@/assets/images/icons/document-pdf.svg" />
          <div class="image-upload-header">Ürün Kılavuzu Yükle</div>
          <span class="image-upload-description"
            >Kılavuzları yüklemek için bilgisayarınızdan seçin veya buraya
            sürükleyip bırakın.</span
          >
          <span class="image-upload-info"
            >(En fazla 3 belge yükleyebilirsiniz.)</span
          >
          <AppButton
            primary
            md
            title="Dosya Seç"
            class="image-upload-button"
            @click="handleDocumentUpload"
          />
          <span class="image-upload-note"
            >Belgeler <strong>.pdf</strong> formatında ve en fazla
            <strong>15 MB</strong> boyutunda olmalıdır.</span
          >
        </div>
        <div class="image-upload-modal-buttons">
          <AppButton
            secondary
            md
            title="Vazgeç"
            class="image-upload-button"
            @click="handleCancelDocumentModal"
          />
          <AppButton
            :disabled="failedDocuments.length > 0"
            primary
            md
            title="Yükle"
            class="image-upload-button"
            @click="uploadSafetyDocuments"
          />
        </div>
      </template>
    </Modal>
  </InfoCard>
</template>

<script setup>
import { ref, watch, computed } from "vue";
import { useStore } from "vuex";
import { Modal, AppButton, Icons } from "@n11/so-ui-components";
import { Sortable } from "sortablejs-vue3";
import Handler from "@/components/Table/Handler.vue";
import InfoCard from "../InfoCard.vue";
import { sendProductDetailEvent } from '@/utils/ga4/helper';
import { GA4_EVENT } from '@/utils/ga4/event';

const store = useStore();

const isProductDisabled = computed(() => store.getters['products/isProductDisabled']);

const isDropdownOpen = ref(false);
const addedSafetyImageModalRef = ref();
const addedSafetyDocumentModalRef = ref();
const sortableImagesContentOpen = ref(false);

const modalImageHeight = computed(() => {
  return sortableImagesContentOpen.value ? '540px' : '500px';
});
const uploadDocumentsModalOpen = ref(false);
const manufacturerInfoRef = ref();
const nutritionRef = ref();
const fileInput = ref(null);
const documentFileInput = ref(null);
const failedFiles = ref([]);
const failedDocuments = ref([]);
const selectedImages = ref([]);
const selectedDocuments = ref([]);
const uploadedSafetyInfoResponse = ref(null);
const uploadedImages = ref([]);
const uploadedDocuments = ref([]);
const productSafetyAdditionalInfoRef = ref();
const imageOrder = ref([]);
const documentOrder = ref([]);
const isSaving = ref(false);
const showSuccessState = ref(false);
const isDirty = ref(false);
const isInitialized = ref(false);
const originalImages = ref([]);
const originalDocuments = ref([]);
const productNutritionTableRef = ref(null);

const props = defineProps({
  isCategorySelected: {
    type: Boolean,
    required: true,
    default: false,
  },
  categoryId: {
    type: Number,
    required: true,
    default: null,
  },
  isNutritionInfoRequired: {
    type: Boolean,
    required: true,
    default: false,
  },
  safetyImages: {
    type: Array,
    default: () => [],
  },
  safetyDocuments: {
    type: Array,
    default: () => [],
  },
  onSaveChanges: {
    type: Function,
    default: null,
  },
  applyToVariants: {
    type: Boolean,
    default: true,
  },
  isSavingAllChanges: {
    type: Boolean,
    default: false,
  },
});
const combinedIsSaving = computed(() => {
  return isSaving.value || (props.isSavingAllChanges && isDirty.value);
});

const combinedIsSaved = computed(() => {
  return !isDirty.value || showSuccessState.value;
});
const emit = defineEmits(['update:applyToVariants', 'hasChanges']);

const handleDocumentSelect = () => {
  if (documentFileInput.value) {
    documentFileInput.value.click();
  }
};

const addedSafetyImageModal = () => {
  sortableImagesContentOpen.value = false;
  addedSafetyImageModalRef?.value?.openModal();
};

const addedSafetyDocumentModalEdit = () => {
  uploadDocumentsModalOpen.value = true;
  addedSafetyDocumentModalRef?.value?.openModal();
};

const addedSafetyImageModalEdit = () => {
  sortableImagesContentOpen.value = true;
  addedSafetyImageModalRef?.value?.openModal();
};

const addedSafetyDocumentModal = () => {
  uploadDocumentsModalOpen.value = false;
  addedSafetyDocumentModalRef?.value?.openModal();
};

const handleDocumentUpload = () => {
   if (documentFileInput.value) {
    documentFileInput.value.click();
  }
};

const handleImageSelect = () => {
  if (fileInput.value) {
    fileInput.value.click();
  }
};

const handleSortableImageSelect = () => {
  if (fileInput.value) {
    fileInput.value.click();
  }
};

const handleSafetyImageModalClosed = () => {
  sortableImagesContentOpen.value = false;
};

const handleSafetyDocumentModalClosed = () => {
  uploadDocumentsModalOpen.value = false;
};

const deleteSafetyImage = (index) => {
  const deletedImage = selectedImages.value[index];
  
  if (deletedImage && (deletedImage.tempId || deletedImage.id)) {
    const tempIdToDelete = deletedImage.tempId || deletedImage.id;
    uploadedImages.value = uploadedImages.value.filter(
      (img) => img.tempId !== tempIdToDelete && img.id !== tempIdToDelete
    );
  }
  
  selectedImages.value.splice(index, 1);

  if (failedFiles.value[index]) {
    failedFiles.value.splice(index, 1);
  }
};

const onFileChange = (event) => {
  const files = event.target.files;
  if (files && files.length > 0) {
    addImagesFromFileList(files);
    event.target.value = "";
  }
};

const addImagesFromFileList = (files) => {
  sortableImagesContentOpen.value = true;
  const maxFiles = 8;
  const currentCount = selectedImages.value.length;
  const remainingSlots = maxFiles - currentCount;

  const maxTotalSize = 10 * 1024 * 1024; // 10 mb total for all images
  const currentTotalSize = selectedImages.value.reduce((sum, img) => {
    return sum + (img.file?.size || 0);
  }, 0);
  let reservedSize = 0;

  Array.from(files)
    .slice(0, remainingSlots)
    .forEach((file) => {
      let errorMessage = "";

    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
    if (!allowedTypes.includes(file.type)) {
      errorMessage = `Dosya uzantısı <strong>.jpeg, .jpg, .png</strong> veya <strong>.webp</strong> formatında olmalıdır.`;
    }

    const prospectiveTotal = currentTotalSize + reservedSize + file.size;
    if (!errorMessage && prospectiveTotal > maxTotalSize) {
      errorMessage = `Seçilen görsellerin toplam boyutu en fazla <strong>10 MB</strong> olmalıdır. Düzenleyip tekrar yükleyin.`;
    }

      const objectUrl = URL.createObjectURL(file);

      if (errorMessage) {
        failedFiles.value.push({
          errorMessage: errorMessage,
          file: file,
          fileName: file.name,
          key: `${file.name}-${Date.now()}`,
          image: objectUrl,
        });
        return;
      }

      reservedSize += file.size;

      const img = new Image();
      img.onload = () => {
        if (img.naturalWidth > 5000 || img.naturalHeight > 5000) {
          reservedSize -= file.size;
          failedFiles.value.push({
            errorMessage: `Resim boyutu en fazla <span class="bold">5000px</span> olmalıdır.`,
            file: file,
            fileName: file.name,
            key: `${file.name}-${Date.now()}`,
            image: objectUrl,
          });
          return;
        }

        selectedImages.value.push({
          file: file,
          key: `${file.name}-${Date.now()}`,
          fileName: file.name,
          title: file.name,
          image: objectUrl,
        });
      };
      img.onerror = () => {
        reservedSize -= file.size;
        failedFiles.value.push({
          errorMessage: "Görsel okunamadı.",
          file: file,
          fileName: file.name,
          key: `${file.name}-${Date.now()}`,
          image: objectUrl,
        });
      };
      img.src = objectUrl;
    });
};

const onImageDragOver = (event) => {
  event.preventDefault();
};

const onImageDrop = (event) => {
  const files = event?.dataTransfer?.files;
  if (files && files.length > 0) {
    addImagesFromFileList(files);
  }
};

const deleteFailedImage = (key) => {
  const index = failedFiles.value.findIndex((file) => file.key === key);
  if (index !== -1) {
    failedFiles.value.splice(index, 1);
  }
};

const handleCancelImageModal = () => {
  addedSafetyImageModalRef?.value?.hiddenModal();
  sortableImagesContentOpen.value = false;
};

const handleCancelDocumentModal = () => {
  addedSafetyDocumentModalRef?.value?.hiddenModal();
  uploadDocumentsModalOpen.value = false;
};

const getDocumentFileError = (file) => {
  const maxSize = 15 * 1024 * 1024; // 15 mb
  if (file.size > maxSize) {
    return `Dosya boyutu en fazla <span class="bold">15 MB</span> olmalıdır. Düzenleyip tekrar yükleyin.`;
  }
  const allowedTypes = ["application/pdf"];
  if (!allowedTypes.includes(file.type)) {
    return `Dosya uzantısı <span class="bold">.pdf</span> olmalıdır. Lütfen kontrol edip tekrar yükleyin.`;
  }
  return "";
};

 const handleDeleteDocument = (key) => {
  let deletedDocument = selectedDocuments.value.find(
    (document) => document.key === key
  );
  
  if (!deletedDocument) {
    const keyParts = key.split('-');
    const possibleId = keyParts[keyParts.length - 1];
    
    deletedDocument = selectedDocuments.value.find(
      (document) => 
        (document.tempId && document.tempId.toString() === possibleId) ||
        (document.id && document.id.toString() === possibleId) ||
        document.key === key
    );
  }
  
  if (!deletedDocument) {
    deletedDocument = failedDocuments.value.find(
      (document) => document.key === key
    );
  }
  
  if (deletedDocument && (deletedDocument.tempId || deletedDocument.id)) {
    const tempIdToDelete = deletedDocument.tempId || deletedDocument.id;
    uploadedDocuments.value = uploadedDocuments.value.filter(
      (doc) => doc.tempId !== tempIdToDelete && doc.id !== tempIdToDelete
    );
  }
  
  failedDocuments.value = failedDocuments.value.filter(
    (document) => document.key !== key
  );
  selectedDocuments.value = selectedDocuments.value.filter(
    (document) => {
      if (document.key === key) return false;
    
      if (deletedDocument && (deletedDocument.tempId || deletedDocument.id)) {
        const tempIdToDelete = deletedDocument.tempId || deletedDocument.id;
        return document.tempId !== tempIdToDelete && document.id !== tempIdToDelete;
      }
      return true;
    }
  );
};

const onDocumentFileChange = (event) => {
  const files = event.target.files;

  if (files && files.length > 0) {
    addDocumentsFromFileList(files);
    event.target.value = "";
  }
};
const onEditDocumentsClick = () => {
  if (isProductDisabled.value) return;
  addedSafetyDocumentModalEdit();
};

const onEditImagesClick = () => {
  if (isProductDisabled.value) return;
  addedSafetyImageModal();
};

const addDocumentsFromFileList = (files) => {
  uploadDocumentsModalOpen.value = true;
  const maxFiles = 3;
  const currentCount = selectedDocuments.value.length;
  const remainingSlots = maxFiles - currentCount;

  Array.from(files)
    .slice(0, remainingSlots)
    .forEach((file) => {
      const errorMessage = getDocumentFileError(file);
      const key = `doc-${
        selectedDocuments.value.length + failedDocuments.value.length
      }-${Date.now()}`;

      if (errorMessage) {
        failedDocuments.value.push({
          errorMessage,
          fileName: file.name,
          key: key,
        });
        return;
      }

      selectedDocuments.value.push({
        file: file,
        key: key,
        fileName: file.name,
      });
    });
};

const onDocumentDragOver = (event) => {
  event.preventDefault();
};

const onDocumentDrop = (event) => {
  const files = event?.dataTransfer?.files;
  if (files && files.length > 0) {
    addDocumentsFromFileList(files);
  }
};

 const uploadSafetyDocuments = async () => {
  const formData = new FormData();

  const newDocumentsToUpload = selectedDocuments.value.filter((doc) => doc.file);
  
  if (newDocumentsToUpload.length > 0) {
    formData.append("type", "DOCUMENT");
    newDocumentsToUpload.forEach((item) => {
      if (item.file) {
        formData.append("file", item.file);
      }
    });

    try {
      const response = await store.dispatch(
        "products/uploadSafetyInfo",
        formData
      );
      uploadedSafetyInfoResponse.value = response;

      if (response && response.data && response.data.tempFiles) {
        const newUploadedDocuments = response.data.tempFiles.map((file, index) => ({
          url: file.filePath,
          tempId: file.id,
          order: uploadedDocuments.value.length + index,
        }));
        
        uploadedDocuments.value = [...uploadedDocuments.value, ...newUploadedDocuments];
      }

      addedSafetyDocumentModalRef?.value?.hiddenModal();
      uploadDocumentsModalOpen.value = false;
    } catch (error) {
      console.error("Belge yükleme hatası:", error);
    }
  } else {
    addedSafetyDocumentModalRef?.value?.hiddenModal();
    uploadDocumentsModalOpen.value = false;
  }
};

const handleImageOrderChange = (event) => {
  const { oldIndex, newIndex } = event;
  const item = selectedImages.value.splice(oldIndex, 1)[0];
  selectedImages.value.splice(newIndex, 0, item);

  imageOrder.value = selectedImages.value.map((img, index) => ({
    key: img.key,
    order: index,
  }));
};

 const handleDocumentOrderChange = (event) => {
  const { oldIndex, newIndex } = event;
  const item = selectedDocuments.value.splice(oldIndex, 1)[0];
  selectedDocuments.value.splice(newIndex, 0, item);

  documentOrder.value = selectedDocuments.value.map((doc, index) => ({
    key: doc.key,
    order: index,
  }));
};

const uploadSafetyImages = async () => {
  const formData = new FormData();
  const successfulImages = selectedImages.value.filter(
    (img) =>
      !failedFiles.value.some(
        (failed) => failed.file && failed.file.name === img.file?.name
      )
  );
  
  const newImagesToUpload = successfulImages.filter((img) => img.file);
  
  if (newImagesToUpload.length > 0) {
    formData.append("type", "IMAGE");
    newImagesToUpload.forEach((item) => {
      if (item.file) {
        formData.append("file", item.file);
      }
    });

    try {
      const response = await store.dispatch(
        "products/uploadSafetyInfo",
        formData
      );
      uploadedSafetyInfoResponse.value = response;

      if (response && response.data && response.data.tempFiles) {
        const newUploadedImages = response.data.tempFiles.map((file, index) => ({
          tempId: file.id,
          order: uploadedImages.value.length + index,
          url: file.filePath,
        }));

        uploadedImages.value = [...uploadedImages.value, ...newUploadedImages];
      }

      addedSafetyImageModalRef?.value?.hiddenModal();
      sortableImagesContentOpen.value = true;
    } catch (error) {
      console.error("Görsel yükleme hatası:", error);
    }
  } else {
    addedSafetyImageModalRef?.value?.hiddenModal();
    sortableImagesContentOpen.value = true;
  }
};

const getProductSafetyInformations = () => {
  const manufacturerInfo = manufacturerInfoRef.value?.getManufacturerInfo();
  const nutritionData =
    productNutritionTableRef.value?.nutritionValuesForRequest || [];
  const nutritionInfo = nutritionRef.value?.getNutritionInfo();
  const additionalInfo = productSafetyAdditionalInfoRef.value?.getData();

  const nutritionInfoWithValues = {
    ...nutritionInfo,
    nutritionValues: nutritionData,
  };

  const imagesArray = uploadedImages.value || [];
  const documentsArray = uploadedDocuments.value || [];

  const result = {
    safetyInfo: {
      providers: manufacturerInfo?.data,
      nutritionInfo: nutritionInfoWithValues,
      additionalInfo: additionalInfo,
      images: [...imagesArray],
      documents: [...documentsArray],
    },
    isValid: manufacturerInfo?.isValid ?? true,
  };

  return result;
};

const processSafetyData = (apiData, targetArray, type) => {
  if (!apiData || !Array.isArray(apiData) || apiData.length === 0) {
    return;
  }

  const prefix = type === 'image' ? 'api-image' : 'api-doc';
  const defaultName = type === 'image' ? 'Görsel' : 'Belge';

  const apiItems = apiData.map((item, index) => {
    const itemId = item.id || item.tempId || index;
    const baseItem = {
      key: `${prefix}-${itemId}`,
      order: item.order,
      tempId: item.id,
      url: item.filePath,
      file: null,
    };

    if (type === 'image') {
      return {
        ...baseItem,
        image: item.url || item.filePath || item,
        title: item.originalName || item.fileName || `${defaultName} ${index + 1}`,
        fileName: item.originalName || item.fileName,
        originalName: item.originalName || item.fileName,
      };
    } else {
      return {
        ...baseItem,
        fileName: item.originalName || item.fileName || item.name || `${defaultName} ${index + 1}`,
        originalName: item.originalName || item.fileName || item.name,
      };
    }
  });

  const existingKeys = new Set(targetArray.value.map(item => item.key));
  const existingUrls = new Set(
    targetArray.value.map(item => item.url || (type === 'image' ? item.image : null)).filter(Boolean)
  );
  const existingTempIds = new Set(
    targetArray.value.map(item => item.tempId || item.id).filter(Boolean)
  );
  
  const newItems = apiItems.filter(item => {
    const itemUrl = item.url || (type === 'image' ? item.image : null);
    const itemTempId = item.tempId || item.id;
    return !existingKeys.has(item.key) && 
           !existingUrls.has(itemUrl) && 
           !existingTempIds.has(itemTempId);
  });

  if (newItems.length > 0) {
    targetArray.value = [...targetArray.value, ...newItems];
  }
};

watch(
  () => [props.safetyImages, props.safetyDocuments],
  () => {
    isInitialized.value = true;
    selectedImages.value = [];
    selectedDocuments.value = [];

    processSafetyData(props.safetyImages, selectedImages, "image");
    processSafetyData(props.safetyDocuments, selectedDocuments, "document");

    originalImages.value = JSON.parse(JSON.stringify(selectedImages.value));
    originalDocuments.value = JSON.parse(JSON.stringify(selectedDocuments.value));

    if (isInitialized.value) {
      showSuccessState.value = false;
    }

    queueMicrotask(() => {
      isInitialized.value = false;
    });
  },
  { immediate: true }
);


watch(
  [selectedImages, selectedDocuments, uploadedImages, uploadedDocuments],
  () => {
    if (isInitialized.value) return;
    isDirty.value = true;
    showSuccessState.value = false;
    emit('hasChanges');
  },
  { deep: true }
);

const handleSaveChanges = async () => {
  if (!props.onSaveChanges) return;

  try {
    isSaving.value = true;

    await props.onSaveChanges();

    const hasImageChanges = JSON.stringify(originalImages.value) !== JSON.stringify(selectedImages.value) || uploadedImages.value.length > 0;
    const hasDocumentChanges = JSON.stringify(originalDocuments.value) !== JSON.stringify(selectedDocuments.value) || uploadedDocuments.value.length > 0;

    const productDetail = store.getters['products/getProductDetail'];
    sendProductDetailEvent(GA4_EVENT.SAVE_CHANGES, {
      button_name: 'Değişiklikleri Kaydet',
      button_type: 'Save Changes',
      button_area: 'Safety Image&Document',
      item_id: productDetail?.id,
      all_variants_checkbox: props.applyToVariants,
      product_image: hasImageChanges,
      product_document: hasDocumentChanges,
    });

    originalImages.value = JSON.parse(JSON.stringify(selectedImages.value));
    originalDocuments.value = JSON.parse(JSON.stringify(selectedDocuments.value));
    uploadedImages.value = [];
    uploadedDocuments.value = [];

    setTimeout(() => {
      showSuccessState.value = true;
      isDirty.value = false;
    }, 0);

    store.commit(
      "common/SET_TOASTER_DATA",
      {
        type: "success",
        title: "Başarılı",
        description: "Yaptığınız değişiklikler kaydedilmiştir.",
      }
    );
  } catch (error) {
    showSuccessState.value = false;

    const errorMessage =
      error?.response?.data?.message ||
      error?.message ||
      "İşlem sırasında bir hata oluştu. Lütfen tekrar deneyin.";

    store.commit(
      "common/SET_TOASTER_DATA",
      {
        type: "error",
        title: "Hata",
        description: errorMessage,
      }
    );

    throw error;
  } finally {
    isSaving.value = false;
  }
};

defineExpose({
  combinedIsSaved,
  getProductSafetyInformations,
  getUploadedSafetyInfoResponse: () => uploadedSafetyInfoResponse.value,
  isDropdownOpen: () => isDropdownOpen.value,
  uploadedImages,
  selectedImages,
  uploadedDocuments,
  selectedDocuments,
  showSaveAllSuccessState: () => {
    showSuccessState.value = true;
    isDirty.value = false;
  },
});
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";
.main-area {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 24px;
  border: 1px solid $colorD20;
  border-radius: 8px;
  margin-bottom: 100px;
}
.toggle-content {
  margin-bottom: unset !important;
  &-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: unset;
  }
}

.description {
  display: flex;
  align-items: baseline;
  font-size: 12px;
  line-height: 16px;

  .arrow-down-gray {
    width: 24px;
    height: 24px;
    cursor: pointer;
  }

  p {
    margin-bottom: 20px;
  }
}
.file-upload-section {
  display: flex;
  justify-content: space-between;
  padding-bottom: 24px;
}
.image-upload {
  &-area {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    height: 325px;
    color: $colorN80;
    background-color: $colorM05;
    border: 2px dashed $colorM50;
    img {
      width: 75px;
      height: 75px;
    }
  }
  &-header {
    font-size: 18px;
    font-weight: 700;
    line-height: 22px;
    margin: 12px 0px 8px 0px;
  }
  &-description {
    font-size: 13px;
    line-height: 18px;
    letter-spacing: -0.05px;
  }
  &-info {
    font-size: 13px;
    font-weight: 600;
    line-height: 18px;
    letter-spacing: -0.05px;
  }
  &-button {
    width: 110px !important;
    margin: 12px 0px;
    cursor: pointer !important;
    z-index: 9;
  }
  &-note {
    font-size: 12px;
    line-height: 16px;
    color: #4F4F4F;
    strong {
      font-weight: bold;
    }
  }
  &-modal-buttons {
    position: absolute;
    bottom: 24px;
    left: 24px;
    right: 24px;
    display: flex;
    gap: 10px;
    z-index: 10;

    button {
      flex: 1;
    }
  }

  &-area-documents {
    height: 300px !important;
  }
}

.product-safety-images,
.products-guide {
  font-size: 11px;
  font-weight: 400;
  line-height: 14px;
  flex: 1;

  &-header-title {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .products-guide-header-title-edit {
      font-size: 12px;
      color: $colorM50;
      cursor: pointer;
    }
  }

  div {
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
    letter-spacing: -0.05px;
  }

  p {
    font-size: 11px;
    font-weight: 400;
    line-height: 14px;
    margin-top: 8px;
  }

  img {
    margin-top: 20px;
  }

  .add-document-button-container {
    display: flex;
    gap: 5px;
    height: 65px;
    margin-top: 16px;

    .add-document-button-item {
      display: flex;
      align-items: center;
      flex: 1;
      gap: 12px;
      border: 1px solid $colorD20;
      border-radius: 8px;
      padding: 12px 16px;
      max-width: 157px;
      height: 64px;

      span {
        font-size: 12px;
        font-weight: 600;
        line-height: 16px;
        color: $colorN80;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 125px;
      }

      img {
        max-height: 40px;
        margin-top: unset;
      }
    }

    &.disabled {
      filter: grayscale(100%);
      opacity: 0.8;
      .add-document-button-item {
        opacity: 0.6;
        pointer-events: none;

        span {
          color: $colorN60;
        }
      }
    }
  }
  .add-image-button-container {
    display: flex;
    gap: 5px;
    align-items: baseline;

    &.disabled {
      .add-image-button-placeholder {
        opacity: 0.6;
        pointer-events: none;
        filter: grayscale(100%);
      }
    }
  }
  .add-button {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 75px;
    cursor: pointer;

    img {
      width: 68px;
      height: 68px;
      margin-top: 12px;
    }

    .add-button-text {
      font-size: 12px;
      font-weight: 600;
      line-height: 16px;
      color: $colorM50;
      text-align: center;
      width: 70px;
    }

    &.disabled {
      cursor: not-allowed;
      pointer-events: none;

      img {
        filter: grayscale(100%);
        opacity: 0.8;
      }
      .add-button-text {
        color: $colorN50;
      }
    }
  }
}

.product-safety-images-header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  &-edit {
    font-size: 12px !important;
    color: $colorM50;
    cursor: pointer;
  }
}
.products-guide {
  margin-left: 16px;
}
.upload-document-area {
  .upload-document-header {
    display: flex;
    align-items: center;
    font-size: 13px;
    margin-bottom: 16px;

    &-title {
      font-weight: 600;
      line-height: 18px;
      letter-spacing: -0.05px;
      padding-right: 16px;
    }
  }
}
.sortable-documents-container {
  display: flex;

  .customize-dnd_handle {
    margin-top: 30px;
  }
}
.upload-document-content {
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;

  &-info-text {
    display: flex;
    flex-direction: column;
    gap: 4px;
    text-align: left;
    margin: 0px 4px 0px 12px;

    &-title {
      font-size: 11px;
      color: #242424 !important;
    }

    span {
      font-size: 12px;
      font-weight: 600;
      line-height: 16px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 170px;
    }

    span:last-child {
      font-size: 14px;
      font-weight: 600;
      line-height: 18px;
      letter-spacing: -0.05px;
      color: $colorD30;
    }
  }

  &-button {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 0 0 auto;
    width: 32%;
    gap: 8px;
    background-color: $colorM05;
    border: none;
    border-radius: 8px;
    padding: 18px 0px;
    height: 128px;
    cursor: pointer;

    span {
      font-size: 16px;
      font-weight: 700;
      line-height: 20px;
      letter-spacing: -0.05px;
      color: $colorM50;
      position: relative;
      z-index: 1;
    }

    .upload-document-button-text {
      font-size: 13px;
      font-weight: 700;
      line-height: 18px;
      background-color: $colorN80;
      color: $colorN00;
      height: 32px;
      padding: 7px 16px;
      border-radius: 4px;
      cursor: pointer;
    }

    &::after {
      content: "";
      background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='100%25' height='100%25' fill='none' rx='12' ry='12' stroke='%23FF44EE' stroke-width='5' stroke-dasharray='6, 14' stroke-linecap='square'/%3E%3C/svg%3E");
      background-position: 50%;
      border-radius: 12px;
      left: 0px;
      top: 0px;
      right: 0px;
      bottom: 0px;
      position: absolute;
    }

    img {
      width: 24px;
      height: 24px;
      position: relative;
      z-index: 1;
    }
  }
  .upload-document-content-item {
    position: relative;
    display: flex;
    flex-direction: column;
    flex: 0 0 auto;

    border-radius: 8px;
    border: 1px solid $colorD20;
    padding: 12px 16px;
    margin: 0px 12px 12px 0px;
    height: 128px;

    &:first-child {
      margin-left: 0px;
    }

    &-process-bar {
      display: flex;
      justify-content: start;
      align-items: baseline;
      gap: 4px;
      font-size: 13px;
      font-weight: 600;
      line-height: 18px;
      letter-spacing: -0.05px;
      color: $colorS50;
      height: 40px;
    }
    &-info {
      display: flex;
      height: 40px;

      img {
        width: 30px;
        height: 40px;
      }
    }

    &-status {
      display: flex;
      align-items: center;
      gap: 5px;
      margin-top: 12px;
      text-align: start;

      span {
        font-size: 13px;
        font-weight: 600;
        line-height: 18px;
        letter-spacing: -0.05px;
        color: $colorS50;
      }
    }
  }
  .upload-document-failed {
    display: flex;
    flex-direction: column;
    gap: 6px;
    font-size: 11px;
    font-weight: 700;
    line-height: 14px;
    color: $colorE50;
    width: 31%;

    span {
      text-align: start;
      font-size: 13px;
      color: $colorE60;
    }

    &-error-message {
      font-size: 11px !important;
      font-weight: 600;
      line-height: 18px;
      letter-spacing: -0.05px;
      color: $colorE50;
    }

    &-header {
      display: flex;
      justify-content: start;
      align-items: center;
      gap: 8px;
    }
  }
}
.added-safety-document-modal,
.added-safety-image-modal {
  .upload-area {
    width: 100%;
    height: 305px;
    background-color: #f2f0fa;
    cursor: pointer;

    &-header {
      font-size: 20px;
      font-weight: 700;
      line-height: 26px;
      letter-spacing: -0.2px;
      color: $colorN80;
      text-align: left;
      cursor: pointer;
      z-index: 10;
      position: relative;

      strong {
        font-weight: 600;
        color: colorN70;
      }
    }
  }
  .ready-status {
    display: block;
    width: 12px;
    height: 12px;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12' fill='none'%3E%3Ccircle cx='6' cy='6' r='6' fill='%23008C20'/%3E%3Cpath d='M8.39961 4.2002L5.39961 7.8002L3.59961 6.0002' stroke='white' stroke-width='1.2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    flex-shrink: 0;
  }
  .sortable {
    &-content {
      display: flex;
      flex-direction: row;
      overflow: hidden;

      &-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 8px;
      }
    }
    &-images {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 8px;
      border: 1px solid $colorD20;
      border-radius: 8px;
      min-height: 260px;
      .image {
        height: 145px;
        width: 98px;
        object-fit: cover;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        object-fit: inherit;
      }
      .image-info {
        height: 105px;
        padding: 0px 8px;
      }
      .image-status {
        display: flex;
        align-items: start;
        gap: 4px;
        font-size: 10px;
        font-weight: 600;
        line-height: 12px;
        color: $colorS50;

        span {
          text-align: start;
        }
      }
      &-info {
        display: flex;
        text-align: center;
        gap: 4px;
        text-align: start;
        font-size: 13px;
        line-height: 18px;
        letter-spacing: -0.05px;
        margin: 12px 0px -12px 0px;
        position: absolute;
        z-index: 9;
      }

      &-area {
        .sortable-images-container {
          display: flex;
          align-items: center;
          justify-content: start;
          gap: 8px;

          div {
            position: relative;
            width: 100px;
          }
        }
        .sortable-header {
          display: flex;
          align-items: center;
          font-size: 13px;
          margin-bottom: 16px;

          &-title {
            font-weight: 600;
            line-height: 18px;
            letter-spacing: -0.05px;
            padding-right: 16px;
          }
        }
      }
    }
    &-drag-area {
      display: flex;
      flex-direction: row;
      gap: 8px;
    }
    &-drag-item {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 4px;
      width: 100px;
      height: 260px;
      background-color: #f2f0fa;
      border-radius: 8px;
      padding: 0px 8px;
      cursor: pointer;
      margin-left: 8px;

      &::after {
        content: "";
        background-position: 50%;
        border-radius: 12px;
        left: 0px;
        top: 0px;
        right: 0px;
        bottom: 0px;
        position: absolute;
        background-color: $colorM05;
        border: 2px dashed $colorM50;
        z-index: 0;
        height: 260px;
      }

      img {
        width: 24px;
        height: 24px;
        position: relative;
        z-index: 1;
      }

      &-placeholder {
        display: flex;
        width: 100px;
        height: 260px;
        background-color: #f6f7f9;
        border-radius: 8px;
        border: 0.5px solid $colorD20;
        cursor: pointer;
      }

      span {
        font-size: 13px;
        font-weight: 700;
        line-height: 18px;
        letter-spacing: -0.05px;
        color: $colorM50;
        position: relative;
        z-index: 1;
      }

      span:last-child {
        font-size: 11px;
        font-weight: 400;
        line-height: 14px;
        color: $colorN80;
        position: relative;
        z-index: 1;
      }

      &-failed {
        display: flex;
        flex-direction: column;
        width: 100px;
        height: 260px;
        background-color: $colorD05;
        border-radius: 8px;
        border: 0.5px solid $colorD20;
        cursor: pointer;
        gap: 8px;

        .image-failed {
          width: 98px;
          height: 140px;
          object-fit: cover;
          border-top-left-radius: 8px;
          border-top-right-radius: 8px;
          border-bottom: 0.5px solid $colorD20;
          background-color: $colorN00;
        }

        .image {
          height: 100px;
          width: 100px;
          object-fit: cover;
          border-top-left-radius: 8px;
          border-top-right-radius: 8px;
          object-fit: inherit;
        }

        .failed-image {
          &-title {
            margin-bottom: 0px !important;
          }

          &-info {
            display: flex;
            flex-direction: column;
            gap: 4px;

            .failed-image-status {
              display: flex;
              gap: 4px;

              img {
                width: 12px;
                height: 12px;
              }

              div {
                font-size: 10px;
                color: $colorE60;
                font-weight: 600;
                line-height: 12px;
              }
            }
          }

          &-description {
            font-size: 10px;
            color: $colorE60;
            font-weight: 600;
            line-height: 13px;
            word-wrap: break-word;
            overflow-wrap: break-word;
          }
        }
        .failed-image-info,
        .image-info {
          min-height: 114px;
          padding: 0px 8px 8px 8px;
        }
        .image-status {
          display: flex;
          align-items: start;
          gap: 4px;
          font-size: 10px;
          font-weight: 600;
          line-height: 12px;
          color: $colorS50;

          span {
            text-align: start;
          }
        }
      }
    }
  }
}

.image-upload-modal-buttons-images {
  position: absolute;
  bottom: 24px;
  left: 24px;
  right: 24px;
  display: flex;
  gap: 10px;
  z-index: 10;

  button {
    flex: 1;
  }
}
.customize-dnd_handle {
  display: inline-flex;
  cursor: move;
  color: $colorD30;
  margin-top: 16px;
  .sortable-drag-icon {
    transition: all 150ms ease-in-out;
    width: 24px;
    height: 24px;
  }
}
.product-safety-images,
.border-line-right {
  position: relative;
  margin-right: 20px;

  &::after {
    content: "";
    position: absolute;
    width: 0.5px;
    height: 100%;
    background-color: $colorD20;
    right: -18px;
    top: 0;
  }
}
.add-image-button-placeholder {
  width: 54px;
  height: 62px;
  border-radius: 8px;
  border: 0.5px solid $colorD20;
}

.failed-image-title,
.image-title {
  display: block;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  color: $colorN80;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 85px !important;
}
.border-line {
  position: relative;
  width: calc(100% + 50px);
  left: -25px;
  border-bottom: 0.5px solid $colorD30;
}
.delete-icon {
  position: absolute;
  content: "";
  z-index: 9;
  border: 0.5px solid $colorD20;
  background-color: $colorN00;
  border-radius: 50%;
  padding: 6px;
  cursor: pointer;
}

.ready-count {
  position: relative;
  border-left: 0.5px solid $colorD30;
  padding: 0px 16px;
}
.failed-count {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: $colorE60;
  font-weight: 600;
  line-height: 16px;
  border-left: 0.5px solid $colorD30;
  padding-left: 16px;
}
.show-category-warning {
  display: flex;
  align-items: center;
  font-size: 13px;
  line-height: 18px;
  letter-spacing: -0.05px;
  color: #4e5c78;
  margin-top: 16px;

  img {
    width: 24px;
    height: 24px;
    margin-right: 8px;
  }
}

.delete-icon {
  position: absolute !important;
  content: "";
  right: 5px !important;
  top: 5px !important;
  width: 25px !important;
  height: 25px !important;
}
.sortable-drag-item-button {
  font-size: 13px !important;
  font-weight: 700;
  line-height: 18px;
  letter-spacing: -0.05px !important;
  color: $colorM50;
  position: relative !important;
  z-index: 1 !important;
}

.header-edit-container {
  display: flex;
  gap: 4px;
  cursor: pointer;

  &.disabled {
    cursor: not-allowed;
    pointer-events: none;

    .edit-icon {
      filter: grayscale(100%);
      opacity: 0.5;
    }

    .product-safety-images-header-edit,
    .products-guide-header-title-edit {
      color: $colorN50;
    }
  }
}

.edit-icon {
  width: 16px;
  height: 16px;
  cursor: pointer;
  margin-top: unset !important;
}

.sortable-drag-item-failed {
  position: relative;
  margin-left: 10px;
}
</style>
